<template>
    <div class="counselling-detail">
        <div class="counselling-detail__question-box" data-cy="counselling-question">
            <div class="counselling-detail__date">
                {{ $t('counselling.questionFromDate', { date: counsellingPost.createdAt }) }}
            </div>
            <div class="counselling-detail__title-container">
                <h1 class="counselling-detail__title">{{ counsellingPost.title }}</h1>
                <nuxt-link
                    v-for="(tag, index) in counsellingPost.tags"
                    :key="index"
                    :to="`${$t('counselling.listLink')}${tag.shopUrlPath}`"
                    class="counselling-detail__tag"
                >
                    {{ tag.title }}
                </nuxt-link>
            </div>
            <div class="counselling-detail__question" v-html="counsellingPost.question"></div>
        </div>
        <div class="counselling-detail__answer" data-cy="counselling-answer">
            <nuxt-link :to="counsellingPost.author.url">
                <ElementsCounsellingResponder class="mb-4" :responder="counsellingPost.author" />
            </nuxt-link>
            <div class="counselling-detail__answer-text" v-html="counsellingPost.answer"></div>
            <IsUseful :post="counsellingPost" />
        </div>
    </div>
    <ModalLogin />
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import CounsellingQuestion from '~/models/Counselling/CounsellingQuestion'
import IsUseful from '~/components/objects/Discussion/IsUseful.vue'
import ModalLogin from '~/components/objects/ModalLogin.vue'

const props = defineProps({
    counsellingPost: {
        type: Object as PropType<CounsellingQuestion>,
        required: true,
    },
})
const { counsellingPost } = toRefs(props)

onMounted(() => {
    useNuxtApp().$bus.$on('openModalForLogin', () => {
        useNuxtApp().$bus.$emit('showModal', 'ask-question-login')
    })
})
</script>

<style lang="scss" scoped>
.counselling-detail {
    border-radius: 10px;
    background: #eee;
    box-shadow: 0px 0px 19px -8px rgba(0, 0, 0, 0.33);
    background: $color-grey;

    &__question {
        line-height: 1.5em;
        font-size: 14px;
    }

    &__question-box {
        padding: 22px;
    }

    &__answer {
        background: #fff;
        padding: 36px 31px 36px 31px;

        @include screen-lg {
            padding: 36px 31px 36px 77px;
        }
    }

    &__answer-text {
        font-size: 14px;
        line-height: 20px;
        color: $color-dark;
    }

    &__date {
        font-size: 12px;
        color: $color-dark;
        margin-bottom: 13px;
    }

    &__tag {
        background: $color-peach;
        border-radius: 100px;
        color: $color-dark;
        padding: 0 10px;
        font-size: 12px;
        font-weight: 590;
        margin-right: 10px;
        margin-bottom: 10px;
        display: inline-block;

        &:hover {
            background: darken($color-peach, 3%);
        }
    }

    &__title-container {
        line-height: 30px;
    }

    &__title {
        font-weight: 450;
        font-size: 20px;
        margin: 0 10px 10px 0;
        display: block;
    }
}
</style>
